module.exports = __webpack_public_path__ + "static/media/laddition-commande-en-ligne.8f48fa8d.png";